module.exports = __webpack_public_path__ + "img/远程诊断.b74acbbc.png";